export default __webpack_public_path__ + "static/media/List-documentation.8ae26397.md";